'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dagPB = require('ipld-dag-pb');

var DAGNode = dagPB.DAGNode;

var multicodec = require('multicodec');

var Unixfs = require('ipfs-unixfs');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

var _require2 = require('buffer'),
    Buffer = _require2.Buffer;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _new2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(template, options) {
      var data, node, cid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {}; // allow options in the template position

              if (template && typeof template !== 'string') {
                options = template;
                template = null;
              }

              if (!template) {
                _context.next = 10;
                break;
              }

              if (!(template === 'unixfs-dir')) {
                _context.next = 7;
                break;
              }

              data = new Unixfs('directory').marshal();
              _context.next = 8;
              break;

            case 7:
              throw new Error('unknown template');

            case 8:
              _context.next = 11;
              break;

            case 10:
              data = Buffer.alloc(0);

            case 11:
              node = new DAGNode(data);
              _context.next = 14;
              return ipld.put(node, multicodec.DAG_PB, {
                cidVersion: 0,
                hashAlg: multicodec.SHA2_256
              });

            case 14:
              cid = _context.sent;

              if (options.preload !== false) {
                preload(cid);
              }

              return _context.abrupt("return", cid);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function _new(_x, _x2) {
      return _new2.apply(this, arguments);
    }

    return _new;
  }());
};